// src/pages/HomeContent.tsx
import React from 'react';
import { Container, Row, Col, Button, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import waterImage from '../assets/images/water-management.jpg';

const HomeContent: React.FC = () => {
  const { isAuthenticated } = useAuth();
  return (
    <Container className="py-5">
      <Row className="align-items-center">
        <Col lg={6} className="mb-4 mb-lg-0">
          <h1 className="display-4 fw-bold mb-4">Sistema de Gestão de Tarifas de Água</h1>
          <p className="lead mb-4">
            Plataforma completa para gerenciamento de clientes, medições, faturamento e atendimento ao cliente para empresas de abastecimento de água.
          </p>
          {!isAuthenticated ? (
            <Link to="/login" style={{ textDecoration: 'none' }}>
              <Button variant="primary" size="lg" className="me-3">
                Acessar o Sistema
              </Button>
            </Link>
          ) : (
            <Link to="/dashboard" style={{ textDecoration: 'none' }}>
              <Button variant="success" size="lg" className="me-3">
                Ir para o Dashboard
              </Button>
            </Link>
          )}
          <Button variant="outline-secondary" size="lg" href="#features">
            Saiba Mais
          </Button>
        </Col>
        <Col lg={6}>
          <Image src={waterImage} alt="Gestão de Água" fluid rounded className="shadow" />
        </Col>
      </Row>

      <Row className="mt-5 pt-5" id="features">
        <Col className="text-center mb-5">
          <h2 className="fw-bold">Recursos Principais</h2>
          <p className="lead">Tudo o que você precisa para gerenciar seu sistema de abastecimento de água</p>
        </Col>
      </Row>

      <Row className="text-center">
        <Col md={4} className="mb-4">
          <div className="p-4 bg-light rounded shadow-sm h-100">
            <i className="fas fa-users fa-3x text-primary mb-3"></i>
            <h3 className="h4 mb-3">Gestão de Clientes</h3>
            <p>Cadastro completo de clientes, histórico de consumo e faturamento, gestão de contratos e muito mais.</p>
          </div>
        </Col>
        <Col md={4} className="mb-4">
          <div className="p-4 bg-light rounded shadow-sm h-100">
            <i className="fas fa-tachometer-alt fa-3x text-success mb-3"></i>
            <h3 className="h4 mb-3">Medição e Consumo</h3>
            <p>Registro de leituras, cálculo automático de consumo, detecção de anomalias e gestão de hidrômetros.</p>
          </div>
        </Col>
        <Col md={4} className="mb-4">
          <div className="p-4 bg-light rounded shadow-sm h-100">
            <i className="fas fa-file-invoice-dollar fa-3x text-warning mb-3"></i>
            <h3 className="h4 mb-3">Faturamento</h3>
            <p>Cálculo automático de tarifas, emissão de faturas, controle de pagamentos e gestão de inadimplência.</p>
          </div>
        </Col>
        <Col md={4} className="mb-4">
          <div className="p-4 bg-light rounded shadow-sm h-100">
            <i className="fas fa-headset fa-3x text-info mb-3"></i>
            <h3 className="h4 mb-3">Atendimento ao Cliente</h3>
            <p>Registro e acompanhamento de solicitações, reclamações, ordens de serviço e comunicação com clientes.</p>
          </div>
        </Col>
        <Col md={4} className="mb-4">
          <div className="p-4 bg-light rounded shadow-sm h-100">
            <i className="fas fa-chart-line fa-3x text-danger mb-3"></i>
            <h3 className="h4 mb-3">Relatórios e Análises</h3>
            <p>Dashboards interativos, relatórios personalizados, indicadores de desempenho e análises estatísticas.</p>
          </div>
        </Col>
        <Col md={4} className="mb-4">
          <div className="p-4 bg-light rounded shadow-sm h-100">
            <i className="fas fa-mobile-alt fa-3x text-primary mb-3"></i>
            <h3 className="h4 mb-3">Acesso Mobile</h3>
            <p>Aplicativo para leituristas, portal do cliente e acesso responsivo para gestão em qualquer dispositivo.</p>
          </div>
        </Col>
      </Row>

      <Row className="mt-5 pt-5">
        <Col className="text-center">
          <h2 className="fw-bold mb-4">Pronto para começar?</h2>
          <p className="lead mb-4">Entre em contato conosco para uma demonstração ou inicie seu período de teste gratuito.</p>
          {!isAuthenticated ? (
            <Link to="/login" style={{ textDecoration: 'none' }}>
              <Button variant="primary" size="lg" className="me-3">
                Acessar o Sistema
              </Button>
            </Link>
          ) : (
            <Link to="/dashboard" style={{ textDecoration: 'none' }}>
              <Button variant="success" size="lg" className="me-3">
                Ir para o Dashboard
              </Button>
            </Link>
          )}
          <Button variant="outline-secondary" size="lg">
            Solicitar Demonstração
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default HomeContent;